<template>
  <div class="list">
    <div class="navMainRight wrap">
      <span>
        <router-link to="/">
          <span style="padding-left: 25px">您所在的位置：</span>
          <span> &nbsp; 首页 &nbsp;>&nbsp; </span>
        </router-link>
      </span>
      <span
        v-if="viewSlideHdParent"
        class="txt1"
        ><a :href="slideHdParentUrl">{{ slideHdParentName }}</a>
      </span>
      <span
        v-if="slideHdName2 != ''"
        class="txt2"
      >
        &nbsp;>&nbsp; {{ slideHdName2 }}
      </span>
      <span
        v-if="isthird"
        class="txt3"
        >&nbsp; > {{ slideHdName1 }}</span
      >
    </div>
    <div class="newcontent wrap">
      <div class="ziNav fl">
        <div class="navMain">
          <div class="navMainLeft">
            <div class="navMaintit">
              <p>{{ slideHdParentName }}</p>
              <div>{{ nameEnglish }}</div>
            </div>
            <div
              :class="{ onActive: active == item.entTChannelUuid }"
              v-for="(item, index) in slideList"
              :key="index"
              class="spanActive"
            >
              <!-- 无三级，有URL，不是建投要闻，跳URL -->
              <a
                class="navMainInner"
                v-if="
                  !item.child.length &&
                  item.url &&
                  item.url !== '' &&
                  item.entTChannelUuid != '02710002'
                "
                target="_blank"
                :href="item.url"
              >
                {{ item.name }}
              </a>
              <!-- 特殊情况：无三级，无url，跳本地 -->
              <a
                class="navMainInner"
                v-if="
                  (!item.child.length && (!item.url || item.url == '')) ||
                  item.entTChannelUuid == '02710002'
                "
                :href="
                  item.catalog === 1
                    ? `/listPage/${item.entTChannelUuid}`
                    : item.catalog === 2
                    ? `/list/${item.entTChannelUuid}`
                    : `/listPic/${item.entTChannelUuid}`
                "
              >
                {{ item.name }}
              </a>
              <!-- 有三级，三级有url，跳url -->
              <a
                class="navMainInner"
                v-if="
                  item.child.length &&
                  item.child[0].url &&
                  item.child[0].url !== ''
                "
                :href="item.child[0].url"
              >
                {{ item.name }}
              </a>
              <!-- 有三级，三级无url，跳本地 -->
              <a
                class="navMainInner"
                v-if="
                  item.child.length &&
                  (!item.child[0].url || item.child[0].url == '')
                "
                :href="
                  item.child[0].catalog === 1
                    ? `/listPage/${item.child[0].entTChannelUuid}`
                    : item.child[0].catalog === 2
                    ? `/list/${item.child[0].entTChannelUuid}`
                    : `/listPic/${item.child[0].entTChannelUuid}`
                "
              >
                {{ item.name }}
              </a>
            </div>
          </div>
          <!-- <div class="navMainRight">
            <div style="float: right">
              <span>
                <router-link to="/">
                  <i class="iconfont">&#xe689;</i> 
                  <span> &nbsp; 首页 &nbsp;>&nbsp; </span>
                </router-link>
              </span>
              <span v-if="viewSlideHdParent" class="txt1"><a :href="slideHdParentUrl">{{slideHdParentName}}</a> </span> 
              <span v-if="slideHdName2!=''" class="txt2"> &nbsp;>&nbsp; {{slideHdName2}} </span>
              <span v-if="isthird" class="txt3">&nbsp; > {{slideHdName1}}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="listMain fr">
        <div class="listContainer">
          <div class="navlittiltit">
            <span v-if="slideHdName2 != ''">{{ slideHdName2 }}</span>
            <span v-if="isthird">> {{ slideHdName1 }}</span>
          </div>
          <ul class="newList">
            <li
              v-for="(item, index) in listData"
              :key="index"
            >
              <!-- 有url，跳url -->
              <a
                class="clearfloat"
                v-if="item.url && item.url !== ''"
                target="_blank"
                :href="item.url"
              >
                <div class="time fl">
                  <p class="">{{ dayjs(item.publishDate).format("DD") }}</p>
                  <p>{{ dayjs(item.publishDate).format("YYYY-MM") }}</p>
                </div>
                <div class="inner fr">
                  <h3 class="single-line">
                    {{ item.title }}
                  </h3>
                  <div style="clear: both"></div>
                  <p class="multi-line1">{{ item.artDesc | ellipsis }}</p>
                </div>
              </a>
              <!-- 正常情况 -->
              <a
                class="clearfloat"
                v-else
                target="_blank"
                :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              >
                <div class="time fl">
                  <p class="">{{ dayjs(item.publishDate).format("DD") }}</p>
                  <p>{{ dayjs(item.publishDate).format("YYYY-MM") }}</p>
                </div>
                <div class="inner fr">
                  <h3 class="single-line">
                    {{ item.title }}
                  </h3>
                  <div style="clear: both"></div>
                  <p class="multi-line1">{{ item.title }}</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="pagin">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :pager-count="7"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>
import { getChildChannel, getChannelInfo, articles } from "@/api/common";
export default {
  data() {
    return {
      istwo: true,
      isthird: false,
      listData: [],
      nameEnglish: "",
      slideHdName1: "",
      slideHdName2: "",
      slideHdTitle: "",
      viewSlideHdParent: true,
      slideHdParentName: "",
      slideHdParentUrl: "",
      slideHdName: "",
      pageCont: "",
      active: "",
      slideHd: {},
      slideList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
    };
  },
  mounted() {
    var _this = this;
    _this.active = _this.$route.params.id;
    _this.getChannelInfo();
    _this.articles();
  },
  filters: {
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 150) {
        return value.slice(0, 150) + "...";
      }
      return value;
    },
  },
  methods: {
    // 查询二级栏目
    getChildChannel(id) {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        parentUuid: id,
      };
      getChildChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.slideList = data;
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true;
            let url = "";
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`;
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`;
            } else {
              url = `/listPic/${_this.slideList[0].entTChannelUuid}`;
            }
            _this.slideHdParentUrl = url;
          } else {
            _this.viewSlideHdParent = false;
          }
        }
      });
    },
    getChannelInfo() {
      var _this = this;
      let params1 = {
        channelUuid: _this.$route.params.id,
      };
      getChannelInfo(params1).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          if (data.parentUuid == "0") {
            _this.slideHdParentName = data.name;
            return;
          } else {
            _this.getChildChannel(data.parentUuid);
          }
          _this.slideHdName1 = data.name;

          let params2 = {
            channelUuid: data.parentUuid,
          };
          getChannelInfo(params2).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              if (data.parentUuid == "0") {
                if (data.name == "公司概况") {
                  _this.nameEnglish = "about us";
                } else if (data.name == "新闻动态") {
                  _this.nameEnglish = "news dynamic";
                } else if (data.name == "企业文化") {
                  _this.nameEnglish = "corporate culture";
                } else if (data.name == "信息公开") {
                  _this.nameEnglish = "Information disclosure";
                } else if (data.name == "联系我们") {
                  _this.nameEnglish = "contact us";
                }
                // _this.getChildChannel(data.entTChannelUuid)
                _this.slideHdParentName = data.name;
                _this.slideHdName2 = _this.slideHdName1;
                _this.slideHdTitle = _this.slideHdName2;
                _this.isthird = false;
              } else {
                _this.isthird = true;
                // _this.getChildChannel(data.parentUuid)
                _this.slideHdName2 = data.name;

                let params3 = {
                  channelUuid: data.parentUuid,
                };
                getChannelInfo(params3).then((res) => {
                  const { code, data } = res;
                  if (code === 1 && data) {
                    _this.slideHdParentName = data.name;
                    _this.slideHdTitle = _this.slideHdName1;
                    // _this.getChildChannel(data.parentUuid)
                  }
                });
              }
            }
          });
        }
      });
    },
    // 获取列表
    articles() {
      var _this = this;
      let id = "";
      var applicationId = "";
      // 他们自己发的集团要闻，不是建投要闻
      if (_this.$route.params.id === "02710003") {
        _this.getjtywarticles();
      } else {
        if (_this.$route.params.id == "02710002") {
          let datajt = {
            entTApplicationUuid: _this.webIdGroup,
            channelUuid: "00190001",
            pageNum: _this.pageNum,
            pageSize: _this.pageSize,
          };
          articles(datajt).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              _this.listData = data.rows;
              _this.total = data.totalRows;
            }
          });
          // id = "00190001";
          // applicationId = _this.webIdGroup;
        } else {
          id = _this.$route.params.id;
          applicationId = _this.webId;
          let data = {
            entTApplicationUuid: applicationId,
            channelUuid: id,
            pageNum: _this.pageNum,
            pageSize: _this.pageSize,
            // entTApplicationUuid:_this.webId
          };
          articles(data).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              _this.listData = data.rows;
              _this.total = data.totalRows;
            }
          });
        }
      }
    },
    // 集团要闻 + 行业动态
    getjtywarticles() {
      var _this = this;
      // 他们原站自己发的集团要闻
      let data1 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "02710003",
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
      };
      articles(data1).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.listData = data.rows;
          _this.total = data.totalRows;
        }
      });
    },
    currentChange(e) {
      var _this = this;
      _this.pageNum = e;
      _this.articles();
    },
  },
};
</script>

<style>
@font-face {
  font-family: "iconfont"; /* Project id 3165120 */
  src: url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff2?t=1644917438066")
      format("woff2"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff?t=1644917438066")
      format("woff"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.ttf?t=1644917438066")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.1px;
  -moz-osx-font-smoothing: grayscale;
}
.newcontent {
  /* width: 1400px; */
  margin: 0 auto;
}
.ziNav {
  height: auto;
  width: 270px;
  background-color: #f3f3f3;
  margin-top: 10px;
}
.navMain {
  /* width: 1400px; */
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.list .navMainLeft {
  width: 100%;
  /* float: left; */
}
.navMaintit {
  width: 100%;
  height: 90px;
  background: url(../assets/img/navbg.png) no-repeat right top;
  background-color: #0062b1;
  color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.navMaintit p {
  padding-left: 20px;
  line-height: 35px;
  font-size: 24px;
  padding-top: 17px;
}
.navMaintit div {
  padding-left: 20px;
  line-height: 20px;
  font-size: 12px;
  text-transform: Uppercase;
}
.spanActive {
  border-top: 1px #fff solid;
  transition: all 0.3s ease-out;
  cursor: pointer;
  height: 56px;
  line-height: 56px;
  box-sizing: border-box;
  font-size: 17px;
}
.spanActive a {
  font-size: 18px;
  color: #0162b3;
}
.spanActive:hover {
  background-color: #0062b1;
}
.spanActive:hover a {
  color: #fff;
}
.navMainInner {
  display: inline-block;
  padding: 0 40px;
  cursor: pointer;
  height: 42px;
  line-height: 43px;
  box-sizing: border-box;
  font-size: 17px;
}
.onActive {
  background-color: #0062b1;
  transition: all 0.3s ease-out;
}
.onActive a {
  color: #fff;
}
.navMainRight {
  overflow: hidden;
  margin: 0 auto;
  margin-top: 10px;
  background: url(../assets/img/mappoint.png) no-repeat;
}
.navMainRight span a {
  float: none;
  font-size: 16px;
  vertical-align: top;
}
.navMainRight span {
  float: none;
  font-size: 16px;
  vertical-align: top;
}
.navMainRight .textTitle {
  float: none;
  font-size: 16px;
  vertical-align: top;
}
.listMain {
  width: calc(100% - 290px);
}
.listContainer {
  width: 100%;
  margin: 10px auto 0;
}
.navlittiltit {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #f3f3f3;
}
.navlittiltit span {
  text-align: left;
  padding-left: 33px;
  font-size: 18px;
  background: url(../assets/img/lmt.png) no-repeat 10px center;
}
.newList {
  width: 100%;
  padding: 0;
}
.newList li {
  width: 100%;
  height: 91px;
  overflow: hidden;
  border-top: 1px solid #f1f1f1;
  padding: 10px 0;
}
.newList li a {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.newList li .time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;
  font-family: 微软雅黑;
  background-color: #f3f3f3;
}
.newList li .time p:nth-child(1) {
  overflow: hidden;
  font-size: 30px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 5px;
}
.newList li .time p:nth-child(2) {
  font-size: 18px;
  overflow: hidden;
  text-align: center;
}
.newList li .inner {
  width: calc(100% - 125px);
  height: 91px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px 0 0 20px;
  /* margin: 0px 0px 0px 0px; */
  background-color: #f3f3f3;
  /* border-left: 1px solid #e5e5e5; */
}
.newList li .inner h3 {
  overflow: hidden;
  font-size: 18px;
  margin-bottom: 5px;
}
.newList li .inner p {
  line-height: 1.5em;
  color: #aeaeae;
  overflow: hidden;
  font-size: 14px;
  font-family: 微软雅黑;
}
.iconnew {
  float: left;
  margin: 7px 5px 0 0;
}
.single-line {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.multi-line1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
/* .newList li a:hover .time {
  transition: all 0.5s ease-in-out;
  color: #fff;
  background-color: #0062b3;
} */
.newList li a:hover .inner,
.newList li a:hover .inner h3 {
  transition: all 0.3s ease-in-out;
  color: #0062b3;
}
.newList li a:hover .inner {
  color: #0062b3;
  /* background-color: #0162b3; */
}
.pagin {
  margin: 0px auto;
  padding: 30px 0 50px;
}
.pagin .el-pagination {
  text-align: center;
}
@media (max-width: 1400px) {
  .listContainer {
    width: 100%;
  }
  .list {
    margin-top: 0px;
  }
  .navMainRight {
    left: 80px;
  }
}
@media (max-width: 1200px) {
  .listMain,
  .ziNav {
    width: 100%;
  }
  .listContainer {
    margin: 0 auto;
  }
}
@media (max-width: 992px) {
  .list .navMainLeft {
    /* width: 70%; */
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
  }
  .navMainRight {
    top: 85px;
    left: 30px;
  }
  .navMainInner {
    padding: 0 5px;
  }
  .newList li .time {
    width: 84px;
    padding: 2px;
    margin: 0;
    height: 92px;
  }
  .newList li .inner {
    width: calc(100% - 100px);
  }
  .newList li .inner h3 {
    margin-bottom: 5px;
  }
  .newList li .time p:nth-child(1) {
    font-size: 30px;
  }
  .newList li {
    height: 100px;
    padding: 10px 0;
  }
  .newList li a {
    height: 92px;
  }
}
@media (max-width: 768px) {
  .list {
    margin-top: 0px;
    margin: 0 auto;
  }
  .listContainer {
    width: 100%;
  }
  .list .navMainLeft {
    width: 100%;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
  }
  .list .navMainLeft::-webkit-scrollbar {
    display: none;
  }
  .newList {
    width: 100%;
  }
}
</style>
